require('./ctxTableResizer.style.scss');

class ctxTableResizerDirective {
    constructor($document, $timeout) {
        this.restrict = 'A';
        this.require = '^ctxTable';
        this.$document = $document;
        this.$timeout = $timeout;
    }

    link(scope, element, attrs, ctxTable) {
        this.$timeout(() => {
            ctxTable.resizableFlag = true;
            this.tableId = element.parents('.table').attr('id');
        }, 0);

        element.on('mousedown', event => {
            event.preventDefault();
            this.haveBodyFlag = ctxTable.$element.find(`#${this.tableId} tbody td:first-child`).width() !== null;
            this.columnIndex = ctxTable.multiSelect ? parseInt(attrs.index) + 2 : parseInt(attrs.index) + 1;
            this.prevOffsetLeft = element.parent().offset().left;
            this.nextOffsetRight = element.parent().next().offset().left + parseInt(element.parent().next().css('width').split('px')[0]);
            ctxTable.initialStartPoint = event.pageX;

            this.setInitialHeadValues(ctxTable, element);

            this.$document.bind('mousemove', event => this.mouseMove(event, element, attrs, ctxTable));
            this.$document.bind('mouseup', () => this.mouseUp(element, ctxTable));
        });
    }

    setInitialHeadValues(ctxTable, element) {
        ctxTable.initialPrevHeadWidth = this.getPrevWidth(element.parent());
        ctxTable.initialNextHeadWidth = this.getNextWidth(element.parent().next());

        this.setPrevWidth(element.parent(), ctxTable.initialPrevHeadWidth, ctxTable, true);
        this.setNextWidth(element.parent().next(), ctxTable.initialNextHeadWidth, ctxTable, true);
    }

    mouseMove(event, element, attrs, ctxTable) {
        const limitSize = 100;
        if (!element.hasClass('visible')) element.addClass('visible');

        if (this.prevOffsetLeft < event.pageX < this.nextOffsetRight) {
            let prevHeadWidth = 0;
            let nextHeadWidth = 0;

            if (event.pageX > ctxTable.initialStartPoint) {
                const diff = event.pageX - ctxTable.initialStartPoint;
                prevHeadWidth = ctxTable.initialPrevHeadWidth + diff;
                nextHeadWidth = ctxTable.initialNextHeadWidth - diff;
            }
            else if (event.pageX < ctxTable.initialStartPoint) {
                const diff = ctxTable.initialStartPoint - event.pageX;
                prevHeadWidth = ctxTable.initialPrevHeadWidth - diff;
                nextHeadWidth = ctxTable.initialNextHeadWidth + diff;
            }

            if ((prevHeadWidth < limitSize) || (nextHeadWidth < limitSize)) return;

            this.setPrevWidth(element.parent(), prevHeadWidth, ctxTable, false);
            this.setNextWidth(element.parent().next(), nextHeadWidth, ctxTable, false);
        }
    }

    mouseUp(element, ctxTable) {
        this.$document.unbind('mousemove');
        this.$document.unbind('mouseup');
        element.removeClass('visible');

        const newPrevHeadWidth = this.getPrevWidth(element.parent());
        const newNextHeadWidth = this.getNextWidth(element.parent().next());
        this.setPrevWidth(element.parent(), newPrevHeadWidth, ctxTable);
        this.setNextWidth(element.parent().next(), newNextHeadWidth, ctxTable);
    }

    getPrevWidth(element) {
        return parseInt(element.css('width').split('px')[0]);
    }

    getNextWidth(element) {
        return parseInt(element.css('width').split('px')[0]);
    }

    setPrevWidth(element, value, ctxTable) {
        element.css('width', value + 'px');
        ctxTable.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex})`).css('width', value + 'px');
    }

    setNextWidth(element, value, ctxTable) {
        element.css('width', value + 'px');
        ctxTable.$element.find(`#${this.tableId} tbody td:nth-of-type(${this.columnIndex + 1})`).css('width', value + 'px');
    }

    static directiveFactory($document, $timeout) {
        return new ctxTableResizerDirective($document, $timeout);
    }
}

ctxTableResizerDirective.directiveFactory.$inject = ['$document', '$timeout'];

module.exports = ctxTableResizerDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxTableResizer/ctxTableResizer.directive.js